import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Loader from 'kepler/lib/components/Loader';
import _find from 'lodash/find';
import AccordionTopicGroup from '../components/AccordionTopicGroup';
import ErrorPanel from '../components/ErrorPanel';
import i18n from '../../lib/reacti18n';
import Page from '../../lib/page';
import Breadcrumb from './Breadcrumb';
import { ARTICLE_LIST, BREADCRUMB_ITEM } from '../constants/PropTypesShapes';

const exp = Page.getUserExperience();
const label = i18n.message(`smarthelp/contentToggle.content.label.desktop.${exp}`);
const maxbcLength = 3;

const ArticleList = (props) => {
  const { articleList, breadcrumb } = props;

  const getActiveTopic = () => {
    let selectedArticle;
    if (breadcrumb && breadcrumb.length && (breadcrumb.length === maxbcLength || Page.isMobileLayout())) {
      selectedArticle = _find(articleList.articleList, (article) => (breadcrumb[breadcrumb.length - 1].id === article.id));
    }
    return selectedArticle;
  };
  const renderArticleList = () => {
    if (!articleList.articleList) {
      return null;
    }
    const options = { name: 'home' };
    Page.setCanonicalTag(options);
    const topics = articleList;
    return <AccordionTopicGroup topics={topics} activeTopic={getActiveTopic()} />;
  };

  const renderContents = () => {
    if (articleList.isLoading) {
      return <Loader size="lg" show type="fixed" />;
    } if (articleList.error) {
      return <ErrorPanel pageName="topicErrorPage" />;
    }
    return renderArticleList();
  };

  const getBreadcrumbItems = () => (
    !articleList.error ? [{
      path: '/home',
      title: label,
    }] : []
  );
  Page.setDocumentTitle(articleList.articleTitle);

  // Currently testing SEO changes for US / UK markets thus we are adding a title meta tag.
  const shouldDisplayMetaFaq = Page.getIsMarketEnabledForSeoTitle();
  const metaTitleText = shouldDisplayMetaFaq ? `${articleList.articleTitle} - FAQ` : '';

  return (
    <div className="topic-articlelist-container">
      <Breadcrumb items={getBreadcrumbItems()} />
      <h1 className="topic-title">{articleList.articleTitle}</h1>
      { shouldDisplayMetaFaq && (<meta name="title" content={metaTitleText} />) }
      <div className="contents">
        { renderContents() }
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    articleList: state.articleList,
    breadcrumb: state.breadcrumb.items,
  };
}

ArticleList.propTypes = {
  articleList: PropTypes.arrayOf(PropTypes.shape(ARTICLE_LIST)).isRequired,
  breadcrumb: PropTypes.arrayOf(PropTypes.shape(BREADCRUMB_ITEM)),
};

ArticleList.defaultProps = {
  breadcrumb: [],
};

export default connect(mapStateToProps)(ArticleList);
